<div class="bp-modal max-w-630">
  <bp-modal-header [title]="'blockpit_tax_modal_title' | translate">
    <a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <hr class="mt-0 mb-0" />
  <div class="bp-modal-body">
    <div class="bp-modal-body-section pt-0">
      <div class="blockpit__subheader">{{ "blockpit_tax_modal_subheader" | translate }}</div>
      <div class="blockpit__image-wrapper">
        <svg-inline 
          class="blockpit__logo" 
          src="/assets/images/svg/bitpanda-blockpit.svg" 
          [alt]="'blockpit_logo_alt_text' | translate" />
      </div>
      <div class="blockpit__item_container">
        <ng-container>
          @for (item of newItems; track item) {
            <div class="blockpit__item">
              <div class="blockpit__icon {{ item.icon }}"></div>
              <div class="blockpit__text_container">
                <div class="blockpit__text_header">
                  {{ "blockpit_tax_modal_item_" + item.key + "_header" | translate }}
                </div>
                <div class="blockpit__text_sub">
                  {{ "blockpit_tax_modal_item_" + item.key + "_sub" | translate }}
                </div>
              </div>
            </div>
          }
        </ng-container>
        <div class="blockpit__button_container">
          <button
            class="btn btn-primary btn-lg mod-button-width font-medium"
            (click)="openBlockpitLink()"
            [disabled]="isButtonDisabled()">
            {{ "blockpit_tax_modal_button" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
